import React, { useState, useEffect } from 'react';
import API from '../../services/api';

// Sub-components import
import CompanyManagement from './OthersPanel/CompanyManagement';
import InvoiceGenerate from './OthersPanel/InvoiceGenerate';
import DeliveryChallan from './OthersPanel/DeliveryChallan';

const OthersPanel = () => {
    const [activeTab, setActiveTab] = useState('company_management');
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        fetchCompanies();
    }, []);

    const fetchCompanies = async () => {
        try {
            const res = await API.get('/companies');
            if (res.data.success) {
                setCompanies(res.data.data);
            }
        } catch (err) {
            console.error('Error fetching companies:', err);
        }
    };

    return (
        <div style={styles.container}>
            {/* TABS NAVIGATION */}
            <div style={styles.tabHeader}>
                <button 
                    style={activeTab === 'company_management' ? styles.activeTabBtn : styles.tabBtn}
                    onClick={() => setActiveTab('company_management')}
                >
                    🏢 Company Management
                </button>
                <button 
                    style={activeTab === 'invoice_generate' ? styles.activeTabBtn : styles.tabBtn}
                    onClick={() => setActiveTab('invoice_generate')}
                >
                    📄 Generate Invoice
                </button>
                <button 
                    style={activeTab === 'delivery_challan' ? styles.activeTabBtn : styles.tabBtn}
                    onClick={() => setActiveTab('delivery_challan')}
                >
                    🚚 Delivery Challan
                </button>
            </div>

            {/* TAB CONTENT RENDERING */}
            <div style={styles.tabContent}>
                {activeTab === 'company_management' && (
                    <CompanyManagement companies={companies} fetchCompanies={fetchCompanies} />
                )}
                {activeTab === 'invoice_generate' && (
                    <InvoiceGenerate companies={companies} />
                )}
                {activeTab === 'delivery_challan' && (
                    <DeliveryChallan />
                )}
            </div>
        </div>
    );
};

const styles = {
    container: { background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' },
    tabHeader: { display: 'flex', gap: '10px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px', marginBottom: '20px' },
    tabBtn: { padding: '10px 20px', background: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', color: '#64748b' },
    activeTabBtn: { padding: '10px 20px', background: '#0f172a', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' },
    tabContent: { padding: '10px 0' }
};

export default OthersPanel;